<template>
  <div class="row border-bottom">
    <div class="col-lg-12">
      <div class="row wrapper border-bottom white-bg page-heading">
        <div class="loader" v-if="loading">
          <div class="loader-img">
            <img src="/static/img/loading.gif" alt="Now Loading..." width="80px" height="80px"/>
          </div>
        </div>
        <div class="col-lg-12">
          <h2>
            <router-link to="/company">
              <img src="/static/img/common/logo.png" style="max-height: 40px;"/></router-link>
            <div class="pull-right">
              <router-link to="/" class="btn btn-default btn-outline btn-xs btn-bitbucket"><i
                class="fa fa-sign-out"></i> Logout
              </router-link>
            </div>
          </h2>
          <ol class="breadcrumb">
            <li v-for="menu in menuList">
              <router-link :to="menu.link">{{menu.name}}</router-link>
            </li>
          </ol>
          <!--<hr class="hr-line-solid">-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '../../service/Api.vue'
  import Csv from '../../service/Csv.vue'

  export default {
    data () {
      return {
        nav: this.$route.meta.nav,
        loading: this.$store.state.modal.isShow,
        tags: this.$store.state.tags,
        company_id: this.$route.params.company_id,
        company: [],
        menuList: [
          {name: '会社管理', link: '/company/'},
          {name: '口コミ(会社確認前)', link: '/company/review/check'},
          {name: '口コミ(公開中)', link: '/company/review?is_public=1'},
          {name: '口コミ(公開前)', link: '/company/review?is_public=0'},
          {name: '会員管理', link: '/member/'},
          {name: 'お問い合わせ', link: '/contact/'}
        ]
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      },
      '$store.state.modal.isShow' (to, from) {
        this.loading = this.$store.state.modal.isShow
      },
      '$store.state.tags' (to, from) {
        this.tags = this.$store.state.tags
      }
    },
    created: function () {
      var tagsResponse = []
      Api.tags().then(response => {
        tagsResponse = response.data.tags
        this.$store.commit('tagRefresh', tagsResponse)
      })
      this.init()
    },
    methods: {
      init: function () {
        this.nav = this.$route.meta.nav
        this.loading = this.$route.meta.loading
        this.company_id = this.$route.params.company_id

        if (this.company_id) {
          Api.company.get(this.company_id)
            .then(this.showSuccess)
            .catch(this.updateFailure)
        }
      },
      showSuccess: function (response) {
        this.company = response.data.company
      },
      updateFailure: function (errors) {
        var data = errors.response.data
        this.errors = data.errors
      },
      downloadMemberAfter: function () {
        Api.member.csvEntryAfter().then(function (response) {
          Csv.download('UNIQUERY_会員登録直後一覧.csv', response.data)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Base.vue?3e9e3724